// extracted by mini-css-extract-plugin
module.exports = {"section":"superhuman-section_section__OX2tF"};